import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { LockIcon } from "@icons";
import styles from "./PeriodLockIcon.module.scss";

interface PeriodLockIconProps {
    label: string;
    testId: string;
}

export function PeriodLockIcon({ label, testId }: PeriodLockIconProps) {
    return (
        <ViewTableCell>
            <Tooltip
                side="top"
                title={label}
                content={
                    <>
                        To unlock, go to <strong>settings &gt; locks</strong>
                    </>
                }
            >
                <button
                    type="button"
                    className={styles.value}
                    aria-label={label}
                    data-testid={testId}
                    onClick={(event) => event.stopPropagation()}
                >
                    <span aria-hidden="true">
                        <LockIcon className="icon-color-current" />
                    </span>
                </button>
            </Tooltip>
        </ViewTableCell>
    );
}
